import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchFavorites } from '@/services/favorites';

export function useFavoritesQuery() {
  const { status, session } = useAuthSession();

  return useQuery({
    queryKey: ['favorites', session?.user.id ?? null],
    queryFn: fetchFavorites,
    enabled: status === 'ready',
  });
}
